module.exports = __webpack_public_path__ + "static/media/placeholder-coffees-subscription.1082aabf.png";